import React from 'react';
import Button from './Button';
import downloadIcon from '../../images/download.svg';

function Download(props){
  let children = props.children || 'Download';
  return (
    <Button
      title={props.title}
      className={props.className}
      icon={downloadIcon}
      onClick={props.onClick}
      type={props.type}
    >
      {children}
    </Button>);
}

export default Download;
